<template>
  <div class="jobsAdd">
    <el-page-header @back="goBack" content="添加部门" style="margin-top: -20px;margin-left: 20px;">
    </el-page-header>
    <el-form class="ruleForm" label-width="160px">
      <el-form-item label="部门名称">
        <el-input v-model="info.name"></el-input>
      </el-form-item>
      <el-form-item label="负责人">
        <el-select v-model="info.leader_name">
          <el-option v-for="(item, index) in innerMemberList" :key="index" :value="item.oausername" @click.native="chooseLeader(item)">{{ item.oausername }}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人电话">
        <el-input type="number" v-model="info.leader_mobile"></el-input>
      </el-form-item>

      <el-form-item label="部门说明">
        <el-input v-model="info.remark" type="textarea" :rows="5"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input type="number" v-model="info.psort"></el-input>
      </el-form-item>

      <el-form-item label="是否在数据统计中">
        <el-radio-group v-model="info.statistics_display">

          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否在数据统计合计中">
        <el-radio-group v-model="info.statistics_total">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="saveData()">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {
    Message
  } from "element-ui";
  import MyUpload from "@/components/upload/index";
  export default {
    components: {
      MyUpload,
    },
    data() {
      return {
        info: {
          name: "",
          remark: "",
          psort: "",
          leader_uid: "",
          leader_name: "",
          leader_mobile: "",
          statistics_display:1,
          statistics_total:0,
        },
        departmentId: "",
        innerMemberList: [],
      }
    },
    mounted() {
      this.departmentId = this.$route.query.id
      if (this.departmentId) {
        this.getInfo()
      }

      this.getInnerMemberList()
    },
    methods: {
      getInfo() {
        let param = {
          id: this.departmentId
        }
        this.gets('architecture/getDepartmentInfo', param).then(res => {
          this.info = res.data.data
        })
      },
      saveData() {
        let that = this;
        this.post('architecture/addDepartment', this.info).then(res => {
          if (res.data.code == 1) {
            Message.success(res.data.msg)
            setTimeout(function() {
              that.$router.go(-1);
            }, 1000);
          } else {
            Message.error(res.data.msg)
          }

        })
      },
      goBack() {
        this.$router.go(-1);
      },
      getInnerMemberList() {
        //职工列表
        this.gets("oasystem/cateadminlist").then((res) => {
          this.innerMemberList = res.data.data;
        });
      },
      //选择负责人
      chooseLeader(info) {
        this.info.leader_uid = info.uid
        this.info.leader_name = info.oausername
        this.info.leader_mobile = info.oamobile
        this.info.leader_utypeid = info.id
      },


      uploadImgSuccess(url, key) {
        this.info[key] = url;
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/entrepriseArchitecture/addEnterpriseDepartment.vue